export default __webpack_public_path__ + "static/media/empty.590465d2.svg";